// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"Tbh0Q","isSelected":"lY32n"};